import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20taking%20selfie%20in%20warm%20sunlit%20room%20with%20large%20window%2C%20soft%20natural%20light%2C%20minimal%20interior%20design%2C%20cream%20walls%2C%20lifestyle%20portrait%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20artistic%20composition&width=1800&height=900&seq=hero-main&orientation=landscape"
        alt="亚洲自拍完全指南"
        className="absolute inset-0 w-full h-full object-cover object-top animate-fade-in"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl font-semibold text-background-50 mb-4 max-w-3xl mx-auto leading-tight animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          亚洲自拍完全指南
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          探索亚洲自拍的完整世界——从专业拍摄技巧、热门滤镜风格，到最佳自拍设备推荐与构图秘诀。无论你是自拍新手还是进阶玩家，这里都有你需要的实用指南。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          <Link
            to="/category/shooting-tips"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始探索
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}